export default "__VITE_ASSET__n1nCIPE1__"